import { Button, Grid } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Field } from "modules/app/components/ContactDetails/Details/styles";
import React, { useEffect, useState } from "react";
import { CompanyTeamsRule, SubmitRule, UsersRule } from "../fields";
import { NameRule } from "../fields/NameRule";

function ByRouting({
  options,
  handleSubmit,
  distribution_type,
  company_id,
  rule,
  users,
  teams,
}) {
  const [attributes, setAttributes] = useState({
    name: rule.name || "",
    broker_role: rule.routing || "",
    conditionals: rule.conditionals || {},
    users: rule.user_ids || [],
    company_teams: rule.company_team_ids || [],
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const attributesErrors = {};

    if (!attributes.broker_role) {
      attributesErrors.broker_role = "Esse campo é obrigatório";
    }

    if (!attributes.name) {
      attributesErrors.name = "Esse campo é obrigatório";
    }

    if (attributes.users.length == 0 && attributes.company_teams.length == 0) {
      attributesErrors.usersOrCompanyTeam =
        "Necessário ao menos um usuário ou uma equipe selecionada";
    }

    setErrors(attributesErrors);
  }, [attributes]);

  function handleClick(e) {
    e.preventDefault();

    const data = {
      rule: {
        company_id: company_id,
        priority: rule?.priority || 99,
        distribution_type: distribution_type,
        routing: "RoundRobin",
        name: attributes.name,
        conditionals: {
          broker_role: attributes.broker_role,
        },
        user_ids: attributes.users,
        company_team_ids: attributes.company_teams,
      },
    };

    handleSubmit(data);
  }

  return (
    <>
      <div
        style={{
          marginTop: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <NameRule
          attributes={attributes}
          setAttributes={setAttributes}
          errors={errors}
        />

        <Grid container alignItems="center" spacing={1}>
          <Grid item style={{ textAlign: "right", width: "20%" }}>
            {options.distribution_types.ByRouting}
          </Grid>

          <Grid item style={{ width: "50%" }}>
            <Autocomplete
              style={{ marginTop: 20 }}
              options={Object.keys(options.distribution_routing_types).map(
                (item) => ({
                  id: item,
                  label: options.distribution_routing_types[item],
                })
              )}
              openOnFocus={true}
              fullWidth
              defaultValue={{
                id: attributes.broker_role,
                label:
                  options.distribution_routing_types[attributes.broker_role],
              }}
              renderInput={(params) => (
                <Field
                  {...params}
                  label={options.distribution_types.ByRouting}
                  variant="outlined"
                  helperText={errors.broker_role}
                />
              )}
              onChange={(_event, value) => {
                if (value) {
                  setAttributes({
                    ...attributes,
                    broker_role: value.id,
                  });
                }
              }}
              getOptionLabel={(field) => field.label}
              getOptionSelected={(option, value) => option.id === value.id}
            />
          </Grid>
        </Grid>

        <CompanyTeamsRule
          rule={rule}
          attributes={attributes}
          setAttributes={setAttributes}
          errors={errors}
          teams={teams}
        />

        <UsersRule
          rule={rule}
          attributes={attributes}
          setAttributes={setAttributes}
          errors={errors}
          users={users}
        />

        <SubmitRule
          disabled={Object.keys(errors).length > 0}
          handleClick={handleClick}
          rule={rule}
        />
      </div>
    </>
  );
}

export default ByRouting;
